import React from 'react'
import Specifications from '../../FastDuplexOligos/Step1/Specifications'
import { SpecificationsComponent } from '@src/queries/ConfiguratorTubesQuery.generated'
import { useBitubeTotalValidationMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import FastSequenceProperties from '../../FastDuplexOligos/Step1/FastSequenceProperties'
import LightCyclerDonor from './LightCyclerDonor'
import { biTubeConfigContext } from '../../BiTube'
import SingleProductEntryButtons from '../../SingleProductEntryButtons'
import { useIntl } from 'react-intl'
import messages from '../../../../messages'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'

const SequenceEntry = (props) => {
  const intl = useIntl()
  const { productDetails, setActive, setItemDetails } = props
  const [bitubeTotalValidation] = useBitubeTotalValidationMutation()
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const { sessionData, callTotalValidation, currentOligoIndex } = bitubeState

  const totalValidation = async (addNew) => {
    const response: any = await bitubeTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    if (response.data) {
      biTubeDispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: response.data.bitubeTotalValidation,
      })
      let flag = false
      response.data.bitubeTotalValidation.forEach((item, index) => {
        const error: any[] = []
        item.listErrors.forEach((err) => {
          delete err.__typename
          error.push(err)
        })
        if (sessionData.length > index) {
          sessionData[index].listError = error
        }
        if (item.listErrors.length !== 0) {
          flag = true
          biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
        }
      })
      if (!flag) {
        if (
          response.data.bitubeTotalValidation[currentOligoIndex].listErrors
            .length === 0
        ) {
          biTubeDispatch({ type: 'HAS_REVIEW_ERROR', data: false })
          biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
          biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: true })
          if (addNew) {
            biTubeDispatch({
              type: 'ADD_NEW_OLIGO',
              data: bitubeState.oligoCount + 1,
            })
          }
        }
      } else {
        if (addNew) {
          biTubeDispatch({
            type: 'SET_PAGE_ERROR',
            data: intl.formatMessage(messages.CONF_OLIGO_ERROR_POPUP_MSG),
          })
          window.scrollTo(0, 0)
        }
      }
    }

    biTubeDispatch({ type: 'CALL_TOTAL_VALIDATION', data: false })
    biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: true })
    biTubeDispatch({
      type: 'ITEM_VALIDATION',
      data: false,
    })
  }

  React.useEffect(() => {
    if (callTotalValidation) {
      totalValidation(true)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callTotalValidation])

  React.useEffect(() => {
    if (bitubeState.itemValidation) {
      totalValidation(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.itemValidation])
  return (
    <>
      <SpecificationsComponent
        ssr={false}
        variables={{
          product: productDetails,
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return <CircleLoader />
          if (error || !data || !data.getSpecifications) return null
          const { getSpecifications } = data
          return (
            <>
              <LightCyclerDonor
                productDetails={productDetails}
                specifications={getSpecifications}
              />
              <FastSequenceProperties productDetails={productDetails} />
              <Specifications
                productDetails={productDetails}
                specificationsData={getSpecifications}
              />
              <SingleProductEntryButtons
                productDetails={productDetails}
                setActive={setActive}
                setItemDetails={setItemDetails}
              />
            </>
          )
        }}
      </SpecificationsComponent>
    </>
  )
}

export default SequenceEntry
